import moment from 'moment';
import { getUserDetails } from './orgName';

export const checkSession = () => {
  const { exp } = getUserDetails();
  const currentTime = moment();
  const expiryTime = moment.unix(exp);
  return currentTime.isAfter(expiryTime);
};
